import { NameDto } from '../../Common/Types'

export interface TransactionAdjustmentPreviewUpload {
  amount: number
  clientName: string
  companyName: string
  direction: NameDto
  tradingAccount: {
    id: string
    name: string
  }
  transactionType: NameDto
  wallet: {
    id: string
    name: string
  }
}

export enum TransactionAdjustmentPreviewUploadKey {
  amount = 'amount',
  clientName = 'clientName',
  companyName = 'companyName',
  direction = 'direction.name',
  tradingAccount = 'tradingAccount.name',
  transactionType = 'transactionType.name',
  wallet = 'wallet.name',
}
